import { type FC, useMemo } from 'react'

import type { HubType } from '@/stores/HubStore'
import { useMobileLayoutStore } from '@/stores/MobileLayoutStore'
import { cn } from '@/util/cn'

const MobileLayouts: Record<HubType, { title: string, descrition: string }> = {
  control: {
    title: 'Reef Control',
    descrition: 'Lite & Pro',
  },
  deluxe: {
    title: 'Reef Control Pro',
    descrition: 'Deluxe',
  },
}

type TabProps = {
  type: HubType
}

const Tab: FC<TabProps> = ({ type }) => {
  const { setActiveMobileTab, activeMobileTab } = useMobileLayoutStore()
  const isActive = useMemo(
    () => activeMobileTab === type,
    [activeMobileTab, type],
  )
  const data = MobileLayouts[type]

  return (
    <button type="button" className="flex flex-col items-center" onClick={() => setActiveMobileTab(type)}>
      <p className={cn('text-base font-bold text-rsf-grey', isActive && 'text-rsf-accent')}>
        {data.title}
      </p>
      <p className="text-xs leading-tight text-rsf-grey md:text-sm">
        {data.descrition}
      </p>
      <div className={cn('mt-3 p-[2px] w-full rounded-lg z-20', isActive ? 'bg-rsf-accent' : 'hidden')}></div>
    </button>
  )
}

function MobileTabs() {
  const isMobile = useMobileLayoutStore(state => state.isMobile)
  if (!isMobile) return <></>

  return (
    <div className="mx-auto w-fit py-6">
      <nav className="flex w-fit flex-col items-center gap-4">
        <div className="flex flex-row justify-center gap-6">
          <Tab type="control" />
          <Tab type="deluxe" />
        </div>
        <div className="-mt-5 w-full rounded-full bg-rsf-grey-light p-px"></div>
      </nav>
    </div>
  )
}

export default MobileTabs
